import { HttpClient, HttpHeaders ,HttpParams} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from "../../environments/environment"
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class HotelManagementService {

   constructor(private http : HttpClient) {}

 


  saveSupplier(result:any) {
   
    let headers = new HttpHeaders();
    return this.http.post(environment.API_URL+"/api/hotelconfig/supplier",result,{headers : headers,observe:"response"});
   }
  
   

   getSupplierList() {
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
        // httpParam=httpParam.append("page", request.page);
        // httpParam=httpParam.append("size", request.size);
        // httpParam=httpParam.append("searchText", search.searchText);

      return this.http.get( environment.API_URL+"/api/hotelconfig/supplier" ,{headers : header, observe : "body", params : httpParam,responseType : "json"})
   
  }



  saveSource(result:any) {
   
    let headers = new HttpHeaders();
    return this.http.post(environment.API_URL+"/api/hotelconfig/source",result,{headers : headers,observe:"response"});
   }
  
   getSourceList() {
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
        // httpParam=httpParam.append("page", request.page);
        // httpParam=httpParam.append("size", request.size);
        // httpParam=httpParam.append("searchText", search.searchText);

      return this.http.get( environment.API_URL+"/api/hotelconfig/source" ,{headers : header, observe : "body", params : httpParam,responseType : "json"})
  
  }
  
  updateSupplier(result:any) {
   
    let headers = new HttpHeaders();
    return this.http.put(environment.API_URL+"/api/hotelconfig/supplier/"+result.code,result,{headers : headers,observe:"response"});
   }
   updateSource(result:any) {
   
    let headers = new HttpHeaders();
    return this.http.put(environment.API_URL+"/api/hotelconfig/source/"+result.code,result,{headers : headers,observe:"response"});
   }
   getSupplierListBySource(sourceCode:any) {
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
        // httpParam=httpParam.append("page", request.page);
        // httpParam=httpParam.append("size", request.size);
        // httpParam=httpParam.append("searchText", search.searchText);

      return this.http.get( environment.API_URL+"/api/hotelconfig/supplier/source/"+sourceCode ,{headers : header, observe : "body", params : httpParam,responseType : "json"})
   
  }

  
}
